import React from 'react'
import author from '../../images/blog/admin.jpg'
import logo from '../../images/logo.png'
import {Link} from 'react-router-dom'

import './style.css'

const BlogSection = (props) => {
    
    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }

     const Blog = [
         {
           blogImg:  props.blogImg1,
           title:"Unlock the Beauty of the Qur'an from the Comfort of Your Home",
           description: "Discover how DarulQuran brings expert Qur'an teaching to your home with qualified tutors, flexible schedules, and a personalised learning journey for all ages.",
           authorName:'DarulQuran Team',
           date:'10 Jun 2024',
           link:"/blog-details-darulquran",
           authorImg: logo
         },
         {
           blogImg:  props.blogImg2,
           title:"Embrace the Light of the Qur'an with DarulQuran's UK-Centric Online Classes",
           description: "Learn how DarulQuran's UK-based online classes offer authentic, tailored Qur'an education for children and adults, with seamless scheduling and supportive tutors.",
           authorName:'DarulQuran Team',
           date:'11 Jun 2024',
           link:"/blog-details-darulquran-2",
           authorImg: logo
         },
     ]
    return(
        <div className="blog-area section-padding">
            <div className="container">
                <div className="col-l2">
                    <div className="wpo-section-title">
                        <span>From Our Blog</span>
                        <h2>Latest News</h2>
                    </div>
                </div>
                <div className="row">
                    {Blog.map((blog, bl) => (
                        <div className="col-lg-6 col-md-12 col-12 custom-grid" key={bl}>
                            <div className="blog-item">
                                <div className="blog-img">
                                <img src={blog.blogImg} alt="" />
                                </div>
                                <div className="blog-content">
                                    <h3><Link onClick={ClickHandler} to={blog.link}>{blog.title}</Link></h3>
                                    <p>{blog.description}</p>
                                    <ul className="post-meta">
                                        <li><img src={blog.authorImg} alt="" /></li>
                                        <li><Link onClick={ClickHandler} to={blog.link}>{blog.authorName}</Link></li>
                                        <li><i className="fa fa-clock-o" aria-hidden="true"></i> {blog.date}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default BlogSection;